import hanaPic from "@/public/images/artists/hana.png";
import { Artist } from "@/types/types";

export const hana = {
  id: "255",
  name: "Hana",
  image: hanaPic,
  description: `Hana has a clean, bright sound that rides high with weightless clarity. She cuts through the beat with sharp, focused phrasing, carrying a smooth, effortless glide through everything she sings.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fhana-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Dance", "Belting"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 50,
        high: 72,
      },
      sweetSpot: 65,
    },
  },
} as const satisfies Artist;
